import React from 'react';
import { IconButton, Popover } from 'material-ui';
import { Picker as EmojiMart } from 'emoji-mart';
import PropTypes from 'prop-types';
import EmojiIcon from 'material-ui/svg-icons/editor/insert-emoticon';
import 'emoji-mart/css/emoji-mart.css';

/**
 * Emoji picker component.
 */
class EmojiPicker extends React.PureComponent {
    state = {
        showEmojiPicker: false
    };

    toggleEmoji = event => {
        event.persist();
        this.setState(({ showEmojiPicker }) => ({
            showEmojiPicker: !showEmojiPicker,
            anchorElem: event.target
        }));
    };

    close = () => this.setState({ showEmojiPicker: false });

    addEmoji = emoji => {
        if (!this.props.disabled) {
            const { native } = emoji;
            if (this.props.inputRef) {
                const { inputRef: input } = this.props;
                const currentVal = typeof this.props.value === 'string' ? this.props.value : '';
                const nextSelectionStart = (currentVal.slice(0, input.selectionStart) + native).length;
                const value =
                    currentVal.slice(0, input.selectionStart) +
                    native +
                    currentVal.slice(input.selectionStart, currentVal.length);
                this.props.onChange(null, value);
                // restore the caret not to be at the end of the line
                setTimeout(() => input.setSelectionRange(nextSelectionStart, nextSelectionStart), 0);
            }
        }
    };

    render() {
        const { disabled } = this.props;
        return (
            <div>
                <IconButton disabled={disabled} onTouchTap={this.toggleEmoji}>
                    <EmojiIcon />
                </IconButton>
                <Popover
                    open={this.state.showEmojiPicker}
                    anchorEl={this.state.anchorElem}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                    onRequestClose={this.close}
                >
                    <EmojiMart onClick={this.addEmoji} />
                </Popover>
            </div>
        );
    }
}

EmojiPicker.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    // eslint-disable-next-line
    inputRef: PropTypes.any
};

export default EmojiPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/pickers/EmojiPicker.js
 **/